import { Space, Table } from "antd";
import { ReButton } from "@/components/refineElement";
import { getLangList } from '@/lib/i18n';
import { hasPermission } from "@/lib/permissionUtil";
import { RoleType } from './types';

type Props = {
  clickRoleEdit: Function;
  clickRoleDelete: Function;
  roleArray: RoleType[];
  setSelectedRoleInfo: Function;
}

function Departments(props: Props) {
  const { clickRoleEdit, clickRoleDelete, roleArray, setSelectedRoleInfo } = props;
  const organizationT: any = getLangList("organization");
  const buttonT: any = getLangList("button");

  const columns = [
    { title: organizationT.ROLE, dataIndex: "roleDesc" },
    {
      title: buttonT.OPERATE,
      dataIndex: "action",
      render: (text: any, record: any) => (
        <Space>
          {hasPermission('ORGANIZATION_PERMISSION_MANAGEMENT_EDIT') && record.roleId !== 2 && // roleId: 2為學生 固定不能修
            <ReButton iconName='edit' onClick={clickRoleEdit(record)} attributeObject={{ size: "small" }}>
              {buttonT.EDIT}
            </ReButton>
          }

          {hasPermission('ORGANIZATION_PERMISSION_MANAGEMENT_EDIT') && record.roleId !== 2 && // roleId: 2為學生 固定不能刪除
            <ReButton iconName='delete' onClick={clickRoleDelete(record.roleId)} attributeObject={{ type: 'danger', size: "small" }}>
              {buttonT.DELETE}
            </ReButton>
          }

          <ReButton iconName='eye' onClick={() => setSelectedRoleInfo(record)} attributeObject={{ type: 'default', size: "small" }}>
            {`${hasPermission('ORGANIZATION_PERMISSION_MANAGEMENT_EDIT') ? buttonT.SETTING : ''}${organizationT.PERMISSION}`}
          </ReButton>
        </Space>
      ),
    }
  ];

  return (
    <Table
      dataSource={roleArray}
      columns={columns}
      pagination={false}
      rowKey="roleId"
      size="small"
    />
  );
}

export default Departments;